import { Component } from "react";
import * as React from "react";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { RootState } from "../../../core/reducers";
import { ThunkDispatch } from "redux-thunk";
import { withRouter, RouteComponentProps } from "react-router";
import ReportByGaitAppV0 from "../v0/Report4RightV0";
import "../../../assets/stylesheets/component/customer.css";
import { getReportByUuid, GetReportByUuidArgs } from "../../../core/actions/institution";
import { getLanguageCode, getCurrentMessages } from "../../../assets/javascripts/intl";

interface StateProps {}

interface DispatchProps {
  getReportByUuid(args: GetReportByUuidArgs): void;
}

interface RouteParams {
  uuid: string;
}

type PropsType = RouteComponentProps<RouteParams> & StateProps;

class DataTrend extends Component<PropsType & DispatchProps> {
  constructor(props: any) {
    super(props);
  }

  componentWillMount() {
    let lang = getLanguageCode();
    document.title = getCurrentMessages()["postureReport"];
    let uuid = this.props.match.params.uuid;
    this.props.getReportByUuid({
      uuid: uuid,
      language: lang,
    });
  }

  goPrint = () => {
    window.print();
  };

  render() {
    return (
      <div className="reportDetail">
        <ReportByGaitAppV0 />
      </div>
    );
  }
}

function mapStateToProps(state: RootState): StateProps {
  return {};
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
  return {
    getReportByUuid(args) {
      dispatch(getReportByUuid(args));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataTrend));
